const Logout = () => {
    // console.log("Logout")

    localStorage.removeItem('user')
    window.location.href = '/';
    return null;
}

export default Logout;